import "./Hero.css";

const Hero = () => {
    return (
        <div className="HeroSection">
            <h1 className="HeroH1">
                Explore the Bible
            </h1>
            <h2 className="HeroH2">
                One Verse At a Time
            </h2>
            <div className="HeroButton">
                GET STARTED
            </div>
        </div>
    );
};

export default Hero;